<template lang="pug">
	.easy-creative--integration-settings.flex-col.space-medium
		template(v-if="editingItem")
			.flex-col.space-large.padding
				.flex-row.space
					DxButton(:text="$tCaption('Back', '@actions')", @click="editingItem = null", icon="fas fa-chevron-left")
				EasyCreativeIntegrationSettingsItem(:item="editingItem")
		.flex-col(v-show="!editingItem")
			ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns")
				template(slot="left-actions")
					.font-big.upper.grey {{$tCaption('Integration settings')}}
				template(v-slot:name-template="{ data }")
					a.flex-row.clickable.hoverable.space.align-center(@click="editingItem = data")
						i.fas.fa-pen-square
						span {{data.Name}}
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import EasyCreativeIntegrationSettingsItem from './EasyCreativeIntegrationSettingsItem.vue'

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative--integration-settings',
		components: {
			DxTextBox, ListView, DxButton, EasyCreativeIntegrationSettingsItem
		},
		data() {
			return {
				settings: [],
				columns: [
					{ dataField: 'Name', caption: this.$tCaption('Name'), serverField: 'Name', cellTemplate: 'name-template' },
					{ dataField: 'ActiveTo', caption: this.$tCaption('ActiveTo'), serverField: 'Name', dataType: 'date' },
					{ dataField: 'Brief.Name', caption: this.$tCaption('Brief'), serverField: 'Brief.Name' },
				],
				editingItem: null
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeIngegrationSettings = this;
		},
		methods: {
			loadData(pageIndex, limit, opts) {
				return this.$Data.getExternalApi('BriefIntegrationSetting/List', `page=${pageIndex}&filterCriteria=["Owner.Oid", "=", "${this.$auth.companyId()}"]`, limit);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--integration-settings {
	}
</style>
